import { useEffect } from "react";
import Navigation from "@/components/Navigation";
import FooterAlt from "@/components/FooterAlt";

const Disclaimer = () => {
  useEffect(() => {
    document.title = "Disclaimer - AMX Ventures";
    const desc = "Website disclaimer and terms of use for AMX Ventures. Information about investment risks, accuracy of content, and website usage terms.";
    let meta = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", desc);

    let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", window.location.href);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Navigation />

      <main className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          <header className="mb-12">
            <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-4">
              Website Disclaimer
            </h1>
            <p className="text-muted-foreground">
              Last Updated: January 2025
            </p>
          </header>

          <div className="space-y-8 text-foreground">
            <section>
              <h2 className="text-2xl font-bold mb-4">General Information</h2>
              <p className="text-muted-foreground leading-relaxed">
                The information provided on this website is for general informational purposes only. All information on the site is provided in good faith, however we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any information on the site.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Investment Disclaimer</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                The content on this website does not constitute financial, investment, tax, or legal advice. Past performance is not indicative of future results. Any investment or portfolio company information presented is for illustrative purposes only and should not be relied upon as a basis for investment decisions.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Before making any investment decision, you should conduct your own research and due diligence and seek professional advice from qualified financial advisors, accountants, and legal counsel.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">No Professional Relationship</h2>
              <p className="text-muted-foreground leading-relaxed">
                Your use of this website and any communication with AMX Ventures through this site does not create a professional relationship between you and AMX Ventures. We do not accept clients or make investment commitments through this website alone.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">External Links Disclaimer</h2>
              <p className="text-muted-foreground leading-relaxed">
                This website may contain links to external websites that are not provided or maintained by AMX Ventures. We do not guarantee the accuracy, relevance, timeliness, or completeness of any information on these external websites. The inclusion of any links does not necessarily imply a recommendation or endorse the views expressed within them.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Errors and Omissions</h2>
              <p className="text-muted-foreground leading-relaxed">
                While we strive to keep the information on this website accurate and up-to-date, we make no representations or warranties about the completeness, accuracy, reliability, suitability, or availability of the information contained herein. Any reliance you place on such information is strictly at your own risk.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Limitation of Liability</h2>
              <p className="text-muted-foreground leading-relaxed">
                Under no circumstance shall AMX Ventures or its affiliates have any liability to you for any loss or damage of any kind incurred as a result of the use of this site or reliance on any information provided on the site. Your use of the site and your reliance on any information on the site is solely at your own risk.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Changes to This Disclaimer</h2>
              <p className="text-muted-foreground leading-relaxed">
                AMX Ventures reserves the right to modify this disclaimer at any time. We encourage you to review this page periodically for any changes. Your continued use of this website following the posting of changes constitutes acceptance of those changes.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Contact Information</h2>
              <p className="text-muted-foreground leading-relaxed">
                If you have any questions about this disclaimer, please contact us at{" "}
                <a href="mailto:arun@amx.ventures" className="text-accent hover:underline font-bold">
                  arun@amx.ventures
                </a>
              </p>
            </section>
          </div>
        </div>
      </main>

      <FooterAlt />
    </div>
  );
};

export default Disclaimer;
